import {AdditionalDataDto} from "./dto/AdditionalDataDto";
import RepositoryWorker from "../RepositoryWorker";

class DeviceAdditionalDataRepository {
    static getByDeviceId(deviceId: number): Promise<AdditionalDataDto> {
        return RepositoryWorker
            .makeGetCallInternal<{additionalData: AdditionalDataDto}>(`/api/v1/devices/${deviceId}`)
            .then(response => response.additionalData);
    }

    static saveDeviceAdditionalData(deviceId: number, data: AdditionalDataDto): Promise<void> {
        return RepositoryWorker
            .makePostCallInternal(`/api/v1/devices/${deviceId}/additional_data`, data);
    }
}

export default DeviceAdditionalDataRepository;